import { PROJECT_BASE } from '../src_frame/fileMap.js'

/* global __FRAME_ORIGIN__ */
// Model frames come back named against the frame's own origin and the project
// base; neither means anything to the user reading a stack.
const STRIP = [PROJECT_BASE, __FRAME_ORIGIN__ + '/']

const errorBar = document.getElementById('error-bar')
const errorName = document.getElementById('error-name')
const errorMessage = document.getElementById('error-message')

// Dismissal is a UI action, not a model result: clear only the visible class
// so the last render state (error included) stands until the next run.
document.getElementById('error-dismiss')?.addEventListener('click', () => errorBar.classList.remove('visible'))

/**
 * @param {unknown} error
 */
export const setError = error => {
  // Headless runs need a settled state to wait for; #progress starts hidden, so
  // its visibility cannot say whether a model has finished (see e2e/render-all.mjs).
  // An error settles the state whenever it arrives; a clear only settles a run
  // that is actually in flight, so an early clear cannot report a pass.
  const root = document.documentElement
  if (error) root.dataset.render = 'error'
  else if (root.dataset.render === 'running') root.dataset.render = 'ok'
  if (error) {
    // Type-safe access to error properties
    const isErrorLike = error && typeof error === 'object'
    const name = (isErrorLike && 'name' in error ? error.name : 'Error') + ': '
    errorName.innerText = name
    const message = formatStacktrace(error)
    errorMessage.innerText = message
    errorBar.classList.add('visible')
  } else {
    errorBar.classList.remove('visible')
  }
}

/**
 * Extracts the stacktrace for an error thrown from inside an eval function.
 * Returns the stacktrace as a string for just the code running inside eval.
 *
 * @param {unknown} error
 * @returns {string} - stacktrace for code inside eval
 */
const formatStacktrace = (error) => {
  // Handle non-object errors
  if (!error || typeof error !== 'object') {
    return String(error)
  }

  // error.stack is not standard but works on chrome and firefox
  const stack = 'stack' in error ? error.stack : undefined
  const message = 'message' in error ? error.message : String(error)
  if (!stack) return message || String(error)

  // chrome stacktrace (script error, syntax error):
  //  ReferenceError: gggggg is not defined
  //  at causeErr (./jscad.model.js:51:3)
  //  at main (./jscad.model.js:46:27)
  //  at ve (blob:null/…:28:2964)  ← bundle.frame-worker.js, not user code
  const cleaned = stack
    .split('\n')
    .filter(line => !line.includes('bundle.frame-worker.js'))
    .map(line => STRIP.reduce((acc, prefix) => acc.replaceAll(prefix, ''), line))

  if (message && !stack.includes(message)) cleaned.unshift(message)
  return cleaned.join('\n')
}